import _ from 'lodash';
import { ConnectorDataModel, ValueLabel } from '../../../shared/models';
import { getAllUserConnectors } from '../../../dataServices';
import { getFailedSyncCustomersFromServer, getSuccessSyncCustomersFromServer } from '../../../dataServices/CustomerDataService';
import { CustomerEntityModel, CustomerGridModel, MyobCustomerModel, NetoCustomerModel } from '../models';
import * as util from '../../../shared/Utilities';

export const getAllConnectorLabels = (
    currentUserId: string
): Promise<Array<ValueLabel>> => {
    return new Promise(async (resolve, reject) => {
        if (_.isEmpty(currentUserId)) {
            resolve([]);
            return;
        }
        const model = await getAllUserConnectors(currentUserId);
        if (model.isSucceed && !_.isEmpty(model?.result)) {
            const list = filterConnectorLabels(model?.result);
            resolve(list);
        } else {
            resolve([]);
        }
    });
};

// Customers are served exclusively via the backend REST API (PostgreSQL-backed,
// via CustomerRepository) - no Customer Firestore reads/listeners in React.
export const getFailedSyncCustomers = (userId: string, connector: string, limit: number, sortField: string, sortOrder: number, firstVisible?: any, lastVisible?: any, mode?: string, query?: any) => {
    return getFailedSyncCustomersFromServer(userId, connector, limit, sortField, sortOrder, firstVisible, lastVisible, mode, query);
}

export const getSuccessSyncCustomers = (userId: string, connector: string, limit: number, sortField: string, sortOrder: number, firstVisible?: any, lastVisible?: any, mode?: string, query?: any) => {
    return getSuccessSyncCustomersFromServer(userId, connector, limit, sortField, sortOrder, firstVisible, lastVisible, mode, query);
}

export const convertCustomerEntityToGridModel = (userData: CustomerEntityModel, index: number) => {
    let formattedDate = util.userTimezone((userData?.lastSyncAt ?? ''));

    return {
        Number: (index + 1).toString(),
        lastSyncAt: formattedDate,
        lastSyncAtForFilter: formattedDate,
        NetoCustomer: transformNetoCustomerModel(userData?.neto),
        MyobCustomer: transformMyobCustomerModel(userData?.myob),
        CompanyOrUser: checkUserIsIndidualOrCompany(userData?.myob),
        Address: mapAddressMyobToNeto(userData?.neto, userData?.myob)
    } as CustomerGridModel
}

const checkUserIsIndidualOrCompany = (user?: MyobCustomerModel) => {
    if (user?.IsIndividual) {
        return user?.FirstName?.concat((user?.LastName ?? ''));
    } else if (user?.CompanyName) {
        return user?.CompanyName
    } else {
        return '';
    }
}

const mapAddressMyobToNeto = (netoCustomer?: NetoCustomerModel, myobCustomer?: MyobCustomerModel) => {
    let addresses = { BillingAddress: {} as any, ShippingAddress: {} as any };
    if (netoCustomer && myobCustomer && !_.isEmpty(myobCustomer?.Addresses)) {
        for (let index = 0; index < myobCustomer?.Addresses?.length; index++) {
            if (index == 0) {
                const address = myobCustomer?.Addresses[index];
                addresses.BillingAddress = address;
                netoCustomer.EmailAddress = !_.isEmpty(address?.Email) ? address.Email : "";
            } else if (index == 1) {
                const address = myobCustomer.Addresses[index];
                addresses.ShippingAddress = address;
                netoCustomer.SecondaryEmailAddress = !_.isEmpty(address?.Email) ? address.Email : "";
            } else {
                break;
            }
        }
    }
    return addresses;
}

const transformNetoCustomerModel = (netoCustomer?: NetoCustomerModel) => {
    if (netoCustomer) {
        return { ...netoCustomer, ActiveText: netoCustomer?.Active === "True" ? "Active" : "InActive" };
    }

    return {} as NetoCustomerModel;
}

const transformMyobCustomerModel = (myobCustomer?: MyobCustomerModel) => {
    if (myobCustomer) {
        return { ...myobCustomer, IsActiveText: myobCustomer?.IsActive === true ? "Active" : "InActive" };
    }

    return {} as MyobCustomerModel;
}

const filterConnectorLabels = (connectors: Array<ConnectorDataModel>) => {
    const labels: Array<ValueLabel> = [];
    connectors?.map((doc: ConnectorDataModel) => {
        labels.push({ label: doc?.label, value: doc?.id });
    });
    return labels;
}
